/**
 * Country Names Pack - Countries from around the world
 * A comprehensive collection of country names in English
 */

import { WordPack } from '../../types/GameTypes';

const countryNamesPack: WordPack = {
  id: 'country-names',
  name: 'Country Names',
  description: 'Countries from around the world - test your geography knowledge',
  difficulty: 'medium',
  words: [
    // Major Countries - Well Known
    "CHINA", "INDIA", "RUSSIA", "BRAZIL", "JAPAN", "MEXICO", "TURKEY",
    "FRANCE", "ITALY", "SPAIN", "POLAND", "GREECE", "EGYPT", "ISRAEL",
    "CANADA", "SWEDEN", "NORWAY", "DENMARK", "FINLAND", "IRELAND",
    "GERMANY", "ENGLAND", "SCOTLAND", "WALES", "AUSTRIA", "HUNGARY",
    "ROMANIA", "BULGARIA", "CROATIA", "SERBIA", "ALBANIA", "ESTONIA",
    "LATVIA", "LITHUANIA", "UKRAINE", "BELARUS", "MOLDOVA", "GEORGIA",
    
    // Americas
    "ARGENTINA", "CHILE", "PERU", "COLOMBIA", "ECUADOR", "VENEZUELA",
    "BOLIVIA", "URUGUAY", "PARAGUAY", "GUYANA", "SURINAME",
    "GUATEMALA", "HONDURAS", "NICARAGUA", "PANAMA", "BELIZE",
    "JAMAICA", "HAITI", "CUBA", "DOMINICA", "BARBADOS", "BAHAMAS",
    "COSTARICA", "ELSALVADOR",
    
    // Africa
    "NIGERIA", "ETHIOPIA", "MOROCCO", "ALGERIA", "TUNISIA", "LIBYA",
    "SUDAN", "KENYA", "UGANDA", "TANZANIA", "RWANDA", "BURUNDI",
    "SOMALIA", "MADAGASCAR", "ZAMBIA", "ZIMBABWE", "BOTSWANA",
    "NAMIBIA", "ANGOLA", "CAMEROON", "GHANA", "SENEGAL", "MALI",
    "NIGER", "CHAD", "GABON", "CONGO", "MALAWI", "MOZAMBIQUE",
    
    // Asia
    "THAILAND", "VIETNAM", "CAMBODIA", "LAOS", "MYANMAR", "MALAYSIA",
    "SINGAPORE", "INDONESIA", "PHILIPPINES", "BRUNEI", "TAIWAN",
    "MONGOLIA", "KAZAKHSTAN", "UZBEKISTAN", "KYRGYZSTAN", "TAJIKISTAN",
    "PAKISTAN", "BANGLADESH", "NEPAL",
    "BHUTAN", "MALDIVES", "YEMEN", "OMAN", "QATAR", "BAHRAIN",
    "KUWAIT", "JORDAN", "LEBANON", "SYRIA", "CYPRUS", "ARMENIA",
    "AZERBAIJAN", "IRAN", "IRAQ",
    
    // Europe
    "BELGIUM", "LUXEMBOURG", "PORTUGAL",
    "SLOVENIA", "SLOVAKIA", "BOSNIA", "MONTENEGRO",
    "KOSOVO", "ICELAND", "MALTA", "MONACO", "ANDORRA",
    
    // Oceania
    "AUSTRALIA", "NEWZEALAND", "FIJI", "SAMOA", "TONGA", "VANUATU",
    "PALAU", "NAURU", "TUVALU", "KIRIBATI",
    
    // Caribbean/Islands
    "TRINIDAD", "TOBAGO", "GRENADA", "SAINTLUCIA",
    "SAINTKITTS", "NEVIS",
    
    // Other Notable
    "SANMARINO"
  ]
};

export default countryNamesPack;